export default __webpack_public_path__ + "static/media/Trailer1.85cd511b.mp4";